import { render, staticRenderFns } from "./StaffProfile.vue?vue&type=template&id=8b193418&scoped=true&"
import script from "./StaffProfile.vue?vue&type=script&lang=js&"
export * from "./StaffProfile.vue?vue&type=script&lang=js&"
import style0 from "./StaffProfile.vue?vue&type=style&index=0&id=8b193418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b193418",
  null
  
)

export default component.exports